import { useGAPageView } from '@equifinance/shared';
import { MainRoutes } from './routes';
import useAppVersionDetector from './hooks/useAppVersionDetector';

function App() {
  useGAPageView();
  useAppVersionDetector(() => {
    window.location.reload();
  });

  return (
    <>
      <MainRoutes />
    </>
  );
}

export default App;
